import React from 'react';
import Alert from 'react-s-alert';


export default class AlertContentTemplate extends React.Component {
  render() {
    let backgroundColor = this.props.customFields.displayComponent ? { backgroundColor: '#f39500' } : {};
    let alertStyles = {
      ...this.props.styles,
      ...backgroundColor,
    };
    return (
      <div className={this.props.classNames} id={this.props.id} style={alertStyles}>
        {
          this.props.customFields.displayComponent ? (
            <div>
              <div className='s-alert-box-inner'>
                {this.props.message}
              </div>
              {this.props.customFields.customButtons ? (
                <div>
                  {this.props.customFields.customButtons.map((button, index) => {
                    return <button key={index} className="whtbtnsm" onClick={(e) => button.handleClick(e, button.param)}>{button.name.toUpperCase()}</button>;
                  })
                  }
                </div>
              ) : (
                <div>
                  <h3>{this.props.customFields.customerName}</h3>
                  <button className="whtbtnsm" onClick={(e) => this.props.customFields.handleButtonClick(e, this.props.customFields.id, this.props.customFields.userID)}>YES</button>
                  <button className="whtbtnsm" onClick={(e) => Alert.closeAll(this.props.id)}>No</button>
                </div>
              )
              }
            </div>
          ) : (
            this.props.message
          )
        }
        <span className='s-alert-close' onClick={(e) => Alert.close(this.props.id)}>close</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/alertComponent.js